import { render } from "./HeroiconsOutlinePhoneMissedCall.vue?vue&type=template&id=3d4cf67c"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePhoneMissedCall.vue"]])

export default __exports__